import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Accordion as AccordionBootstrap, Card, Button as ButtonBoostrap } from 'react-bootstrap';
import HelpButton from '../../atoms/helpButton/helpButton';
import Button, { ButtonSize, ButtonTheme, ButtonType } from '../../atoms/button/button';
import './accordion2.scss';
/**
 * Accordion is used to group of HTML or component elements. It has a header Button, HelpButton, Catalog button and an area to group HTML or component elements. If the user clicks on the header button, the content is hidden or showed.
 */
const Accordion2 = (props) => {
  const {
    id, headers,body,moreInfo,
  } = props;
  const [selected,setSelected] =useState(null);
  const handlerSelect=(e)=>{
    console.log(e);
    setSelected(e-1);
  }
  return (
    <AccordionBootstrap id={id} defaultActiveKey="0" className={"accordion2"} onSelect={handlerSelect}>
        {headers && headers.map((item,index)=>{
            return   <Card key={index} className="accordion2-card">
            <Card.Header className="accordion__header">
                <div className="drawer-block drawer-item drawer-item-size">
                     <div className="drawer-item-1">
                       {index+1}
                     </div>
                     <div className="drawer-item-2">{item}
                     </div>
                     {moreInfo==true && <div className="drawer-item-3">
                        <AccordionBootstrap.Toggle as={ButtonBoostrap} variant="outline-info" eventKey={index+1}>
                         {index==selected?"Less info":"More info"}
                         </AccordionBootstrap.Toggle>
                     </div>}
             </div>  
            </Card.Header>
            <AccordionBootstrap.Collapse eventKey={index+1}>
              <Card.Body className="drawer-accordion-body">
                {body[index]}
              </Card.Body>
            </AccordionBootstrap.Collapse>
          </Card>
           })}
    </AccordionBootstrap>
  );
};

Accordion2.propTypes = {
  /**
   * component id
   */
  id: PropTypes.string,
  /**
   * Accordion title
   */
  title: PropTypes.string,
  /**
   * JSX content to display inside the accordion
   */
  children: PropTypes.node,
  /**
   * Text to add inside the header help button
   */
  helpText: PropTypes.string,
  /**
   * Function to bind Catalog link onClick
   */
  onClickLoadFromCatalog: PropTypes.func,

    /**
   * Function to bind Catalog link onClick
   */
  onClickRemove: PropTypes.func,
    /**
   * Accordion duplication
   */
  canDuplicate: PropTypes.bool,
};

Accordion2.defaultProps = {
  id: '',
  title: '',
  children: '',
  helpText: '',
  onClickLoadFromCatalog: null,
  onClickRemove: null,
  onClickDuplicate: null,
  moreInfo:false
};
export default Accordion2;
